import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtilsService } from '@geekeno/ngx-website/services';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-contact-form',
  imports: [FormsModule],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss',
})
export class ContactFormComponent implements AfterViewInit {
  private http = inject(HttpClient);

  private utils = inject(UtilsService);
  readonly source = input<string>('unknown');
  readonly close = output<void>();
  readonly firstNameInput = viewChild.required<ElementRef>('firstNameInput');

  contactForm = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    company: '',
    requirements: '',
    source: '',
  };

  isSubmitting = false;
  submitSuccess = false;
  submitError = '';

  constructor() {
    this.resetForm();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const firstNameInput = this.firstNameInput();
      if (firstNameInput) {
        firstNameInput.nativeElement.focus();
      }
    });
  }

  submitForm() {
    this.isSubmitting = true;
    this.submitSuccess = false;
    this.submitError = '';

    const payload = {
      ...this.contactForm,
      source: this.source(),
    };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const url = this.utils.isPlatformServer
      ? `${environment.backendUrl}/api/client/`
      : '/api/client/';
    this.http.post(url, payload, { headers }).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.submitSuccess = true;
      },
      error: (error) => {
        this.isSubmitting = false;
        this.submitError = 'Failed to send message. Please try again.';
        console.error(error);
      },
    });
  }

  resetForm() {
    this.contactForm = {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      company: '',
      requirements: '',
      source: '',
    };
  }
  closeForm() {
    this.close.emit();
  }
}
